exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selected-button{background-color:#e9ecef!important;color:#222328!important;border-color:#dee2e6!important}.btn-group .btn{margin-right:5px}.page-link{color:#000!important}.date-error-msg{margin-left:10px}.title-text{color:#c10e21;text-decoration:underline;margin-bottom:10px!important}.custom-clear-filter-btn{background-color:transparent!important;color:#c10e21!important;border:1px solid #c10e21!important}.item-title:hover{color:#c10e21;text-decoration:underline}.funding-opportunities .page-item.active .page-link{background-color:#dee2e6!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5986f381","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/app/components/phd/aha-search-funding-opportunities.vue
// module id = 509
// module chunks = 0 1